<div class="col-12 flex flex-wrap">
  <div class="col-4 flex flex-wrap" style="float: left;" *ngIf="FileIdEnc != null">
    <p-table [value]="lstKeyValueDocumentInfo"
             [styleClass]="'primary p-datatable-striped'"
             [tableStyle]="{ 'min-width': '20rem' }"
             style="height: 90%! important ; color: red;">
      <ng-template pTemplate="body"  let-record>
        <tr class="w-full cursor-pointer texts" >
          <td style="max-width: 2rem;">{{record.Key}}</td>
          <td style="max-width: 2rem;">{{record.Value}}</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex justify-content-end footer">
      <i class="pi pi-print mr-2 font-bold cursor-pointer flex justify-content-end " [pTooltip]="'Stampa'" (click)="print()"></i>
      <label class="mr-6 cursor-pointer" (click)="print()">Stampa</label>
      <i class="pi pi-download mr-2 font-bold cursor-pointer flex justify-content-end " [pTooltip]="'Download'" (click)="download()"></i>
      <label class="mr-6 cursor-pointer" (click)="download()">Download</label>
    </div>
  </div>

  <div *ngIf="FileIdEnc == null" class="col-12 flex">
    <i class="pi pi-print mr-2 font-bold cursor-pointer flex justify-content-end " [pTooltip]="'Stampa'" (click)="print()"></i>
    <label class="mr-6 cursor-pointer" (click)="print()">Stampa</label>
    <i class="pi pi-download mr-2 font-bold cursor-pointer flex justify-content-end " [pTooltip]="'Download'" (click)="download()"></i>
    <label class="mr-6 cursor-pointer" (click)="download()">Download</label>
  </div>

  <div class="flex flex-wrap"  [ngClass]="{ 'col-8': FileIdEnc != null,
                                            'col-12': FileIdEnc == null }">
    <pdf-viewer [src]="src"
      [render-text]="true"
      [original-size]="false"
      class="containerPdfViewer"
    ></pdf-viewer>
  </div> 
  
</div>
